import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogConfig, MatTableDataSource} from '@angular/material';
import {fuseAnimations} from '../../../../../core/animations';
import {Observable} from 'rxjs/Observable';
import {AuthenticationService} from '../../../../services/authentication/authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {CourseYearService} from '../../../../services/cour-years/course-year.service';
import {TranslationService} from '../../../../services/translation/translation.service';
import {SweetAlertService} from '../../../../services/sweet-alert/sweet-alert.service';
import {SubjectDivisionTeacherService} from '../../../../services/subject-division-teachers/subject-division-teacher.service';
import {AddEditSubjectTeacherComponent} from './components/add-subject-teacher/add-edit-subject-teacher.component';
import {DivisionSubjectDto, SubjectTeacherDto} from '../../../../models/divisions/division-subject';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import { DivisionService } from '../../../../services/divisions/division.service';
import { Location } from '@angular/common';

@Component({
    selector: 'fuse-subject-division-teacher',
    templateUrl: './subject-division-teacher.component.html',
    styleUrls: ['./subject-division-teacher.component.scss'],
    animations: fuseAnimations
})
export class SubjectDivisionTeacherComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns: string[] = ['SubjectName', 'MainTeacher', 'SubstituteTeacher', 'Actions'];
    public dataSource: MatTableDataSource<any>;
    public sub: any;
    public divisionId: number;
    confirmDialogRef: any;
    public division: any;

    constructor(private authenticationService: AuthenticationService,
                public dialog: MatDialog,
                private router: Router,
                private route: ActivatedRoute,
                private courseYearService: CourseYearService,
                private fb: FormBuilder,
                private translationService: TranslationService,
                private sweetAlertService: SweetAlertService,
                private divisionService: DivisionService,
                private location: Location,
                private subjectDivisionTeacherService: SubjectDivisionTeacherService) {

    }


    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    ngOnInit(): void {
        this.blockUI.start();
        this.sub = this.route.params.subscribe(params => {
            this.divisionId = params['id'] !== undefined ? +params['id'] : -1;
        });

        Observable.combineLatest(
            this.subjectDivisionTeacherService.getAllByDivision(this.divisionId),
            this.divisionService.getById(this.divisionId)
        ).subscribe(([subjects, division]: any) => {
            this.dataSource = new MatTableDataSource(subjects);
            this.division = division;
            this.blockUI.stop();
        });
    }

    editOrView(mode: string, subject: DivisionSubjectDto) {
        if (!subject.MainTeacher) {
            subject.MainTeacher = new SubjectTeacherDto();
        }
        if (!subject.SubstituteTeacher) {
            subject.SubstituteTeacher = new SubjectTeacherDto();
        }
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: mode,
                divisionId: this.divisionId,
                subject: JSON.parse(JSON.stringify(subject))
            }
        };

        this.confirmDialogRef = this.dialog.open(AddEditSubjectTeacherComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('result', result);
            if (result) {
                subject.MainTeacher = result.MainTeacher;
                subject.SubstituteTeacher = result.SubstituteTeacher;
            }
        });
    }
    back() {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/subject-division-teacher/subject-division-teacher.component.ts